module.exports = __webpack_public_path__ + "img/no_items_yet.b2d2f6bd.svg";